<template>
  <div>
    <header class="Header">
      <div class="Header__inner">
        <router-link to="/" class="Header_menu__logo Header_menu__logo--sm">
          <img class="Header_menu__logo_img" src="assets/img/melon_logo_blue.png" alt="MELON ONLINE">
        </router-link>
      </div>
    </header>
    <div class="contents contents--pt">
      <section class="Form _min-h">
        <div class="inner Form__position">
          <div class="Form__thanks_area">
            <h1 class="Form__head Form__head_thanks">
              ご登録が完了しました
            </h1>
            <p class="Form__thanks_tx">
              ご登録いただき、ありがとうございます。<br>
              ご登録いただいたメールアドレス宛に、クラスへの参加方法などMELONの使い方をご説明するメールをお送りいたしました。
            </p>
            <router-link to="/signin" class="Btn__blue Form__log_btn">
              ログインはこちら
            </router-link>
            <div class="Form__note _font-md">
              ※数分たってもメールが届かない場合は、<br class="_dsp-none--sp">
              お手数ですが<a class="_cl-04" href="mailto:info@the-melon.com">info@the-melon.com</a>へご連絡ください。
            </div>
          </div>
          <img class="Form__thanks_img" src="assets/img/form_thanks.png" alt="ご登録が完了しました">
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterThanks'
}
</script>
